import {
  failureEjectPowerbank,
  failurePowerBnakIsOnlineOffline,
  failureStationAdd,
  failureStationAttentionsList,
  failureStationDelete,
  failureStationList,
  failureStationSummary,
  failureStationView,
  failureSyncStationSheet,
  removeEjectedPowerbankFromStation,
  requestEjectPowerbank,
  requestPowerBnakIsOnlineOffline,
  requestStationAdd,
  requestStationAttentionsList,
  requestStationDelete,
  requestStationList,
  requestStationSummary,
  requestStationView,
  requestSyncStationSheet,
  responseEjectPowerbank,
  responsePowerBnakIsOnlineOffline,
  responseStationAdd,
  responseStationAttentionsList,
  responseStationDelete,
  responseStationList,
  responseStationSummary,
  responseStationView,
  responseSyncStationSheet,
} from '../../slices/stationSlice/stationSlice';
import Swal from 'sweetalert2';
import requestApi from 'utils/Request';
import { EJECT_POWERBANK } from 'utils/StaticApiEndpoints';
import { STATION_STATUS } from 'utils/StaticApiEndpoints';
import { STATION_ATTENTION } from 'utils/StaticApiEndpoints';
import { STATIONLIST } from 'utils/StaticApiEndpoints';
import { STATION_SUMMARY } from 'utils/StaticApiEndpoints';
import { STATION } from 'utils/StaticApiEndpoints';
import { SYNC_STATION_SHEET } from 'utils/StaticApiEndpoints';

export const ListStationData = (payload) => async (dispatch) => {
  try {
    dispatch(requestStationList());
    const res = await requestApi.get(STATIONLIST, { params: payload });
    dispatch(responseStationList(res));
  } catch (error) {
    Swal.fire({
      icon: 'error',
      text: error?.message,
    });
    dispatch(failureStationList(error?.message));
  }
};

export const AddStationData = (payload, callback) => async (dispatch) => {
  try {
    dispatch(requestStationAdd());
    const res = await requestApi.post(STATION, payload);
    dispatch(responseStationAdd(res));
    if (typeof callback === 'function') {
      callback();
    }
  } catch (error) {
    Swal.fire({
      icon: 'error',
      text: error?.message,
    });
    dispatch(failureStationAdd(error?.message));
  }
};

///// eject powerbank ////
export const EjectPowerbankData = (payload, callback) => async (dispatch) => {
  try {
    dispatch(requestEjectPowerbank());
    const res = await requestApi.post(`${EJECT_POWERBANK}`, payload);
    dispatch(responseEjectPowerbank(res));

    dispatch(removeEjectedPowerbankFromStation(res.data));
    if (typeof callback === 'function') {
      callback();
    }
  } catch (error) {
    Swal.fire({
      icon: 'error',
      text: error?.message,
    });
    dispatch(failureEjectPowerbank(error?.message));
  }
};

////// detail Station /////
export const ViewStationData = (payload) => async (dispatch) => {
  try {
    dispatch(requestStationView());
    const { data } = await requestApi.get(`${STATION}/${payload?.id}`, payload);
    dispatch(responseStationView(data));
  } catch (error) {
    Swal.fire({
      icon: 'error',
      text: error?.message,
    });
    dispatch(failureStationView(error?.message));
  }
};

/////// edit merchnat ///
export const EditStationData = (id, payload, callback) => async (dispatch) => {
  try {
    dispatch(requestStationAdd());
    const res = await requestApi.put(`${STATION}/${id}`, payload);
    dispatch(responseStationAdd(res));
    if (typeof callback === 'function') {
      callback();
    }
  } catch (error) {
    Swal.fire({
      icon: 'error',
      text: error?.message,
    });
    dispatch(failureStationAdd(error?.message));
  }
};

///// delete Station ///
export const DeleteStationData =
  (id, payload, callback) => async (dispatch) => {
    try {
      dispatch(requestStationDelete());
      const res = await requestApi.delete(`${STATION}/${id}`, payload);
      dispatch(responseStationDelete(res));
      if (typeof callback === 'function') {
        callback();
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        text: error?.message,
      });
      dispatch(failureStationDelete(error?.message));
    }
  };

////// powerbnak is online or offline ////
export const ListStationStatus = (id, payload) => async (dispatch) => {
  try {
    dispatch(requestPowerBnakIsOnlineOffline());
    const res = await requestApi.get(`${STATION_STATUS}/${id}`, {
      params: payload,
    });
    dispatch(responsePowerBnakIsOnlineOffline(res.data));
  } catch (error) {
    Swal.fire({
      icon: 'error',
      text: error?.message,
    });
    dispatch(failurePowerBnakIsOnlineOffline(error?.message));
  }
};

///////// Station attentions ////////
export const ListStationAttentions = (payload) => async (dispatch) => {
  try {
    dispatch(requestStationAttentionsList());
    const res = await requestApi.get(STATION_ATTENTION, { params: payload });
    dispatch(responseStationAttentionsList(res));
  } catch (error) {
    Swal.fire({
      icon: 'error',
      text: error?.message,
    });
    dispatch(failureStationAttentionsList(error?.message));
  }
};

////////// Station Summary //////////
export const GetStationSummary = () => async (dispatch) => {
  try {
    dispatch(requestStationSummary());
    const res = await requestApi.get(STATION_SUMMARY);
    dispatch(responseStationSummary(res));
  } catch (error) {
    Swal.fire({
      icon: 'error',
      text: error?.message,
    });
    dispatch(failureStationSummary(error?.message));
  }
};

////////// Sync Station Data to Google Sheet //////////
export const SyncStationSheet = (callback) => async (dispatch) => {
  try {
    dispatch(requestSyncStationSheet());
    const response = await requestApi.post(SYNC_STATION_SHEET);
    dispatch(responseSyncStationSheet(response));
    Swal.fire({
      icon: 'success',
      text: response.message,
    }).then(() => {
      if (typeof callback === 'function') callback();
    });
  } catch (error) {
    Swal.fire({
      icon: 'error',
      text: error?.message,
    });
    dispatch(failureSyncStationSheet(error?.message));
  }
};
